<template>
  <div
    class="home"
    ref="home"
    :class="{ 'home-overlapped': isHeaderOverlapped }"
  >
    <!--头部-->
    <Navbar :isNotify="false" :isCustomerService="false" :showLeft="false">
      <template #left>
        <div class="left-content">
          <img
            class="guide-logo-icon"
            src="@/assets/style/home-title-bg.png"
            alt=""
          />
          <div class="text">
            <span style="font-weight: 600">新享管家</span>
            <span class="tip">应急周转 秒批秒到更省心</span>
          </div>
        </div>
      </template>
      <template #right>
        <div class="right-content">
          <img
            @click="handleClickNotify"
            class="notifyIcon"
            src="@/assets/style/notify-icon.png"
            alt=""
          />
          <img
            @click="handleClickCustomerService"
            class="customerServiceIcon"
            src="@/assets/style/customer-service-icon.png"
            alt=""
          />
        </div>
      </template>
    </Navbar>
    <div class="content" ref="content">
      <!-- 贷款申请卡片 -->
      <LoanCard />
      <div ref="contentSentinel" class="content-sentinel"></div>
    </div>
    <div :class="{ 'content-sentinel-overlapped': isHeaderOverlapped }"></div>
    <div class="product-recommend-card" v-if="productList?.length > 0">
      <div class="title" :class="{ 'title-overlapped': isHeaderOverlapped }">
        <span style="font-weight: 600">产品推荐</span>
        <span class="tip">（所有推荐产品均与本产品无关，请注意识别）</span>
      </div>
      <div class="product-list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="暂无更多数据"
          @load="onLoad"
        >
          <div v-for="item in productList" :key="item.id">
            <div class="product-item" @click="goDetail(item)">
              <div class="left">
                <img :src="item.img" alt="" />
                <div class="product-content">
                  <span class="name single-line">{{ item.name }}</span>
                  <span class="tip single-line">{{ item.explainStr }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!--保障申明-->
    <div class="warrantyStatement" v-if="productList?.length === 0 && isNoData">
      <warrantyStatement :show="false" />
    </div>
    <div v-if="isHeaderOverlapped" :class="{ 'up-icon': isHeaderOverlapped }">
      <div @click="scrollToTop" class="icon">
        <img src="@/assets/style/up-icon.png" alt="" />
      </div>
      <span>返回顶部</span>
    </div>
    <div class="block"></div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import { tabList } from "@/utils/const";
import LoanCard from "@/components/home/loanCard.vue";
import { getHomeData, getAdList } from "@/api/index";
import warrantyStatement from "@/components/landingPage/warrantyStatement.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    LoanCard,
    warrantyStatement,
  },
  data() {
    return {
      tabList,
      isHeaderOverlapped: false,
      productList: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      pageSize: 10,
      isNoData: false, // 是否没有数据
    };
  },
  async mounted() {
    this.onLoad();
    const res = await getHomeData({});
    if (res.code === 2000) {
      this.$store.commit("setHomeData", res.data);
    } else {
      this.$toast(res.message);
    }
    this.$nextTick(() => {
      this.initHeaderOverlapObserver();
    });
  },
  beforeDestroy() {
    this._contentObserver?.disconnect();
    this._contentObserver = null;
  },
  methods: {
    
    scrollToTop() {
      this.$refs.home.scrollTop = 0;
    },
    goDetail(item) {
      console.log(item,"item");
        //去其他产品
        if (process.env.VUE_APP_ENV === "productionApp") {
          this.$JSBridge.send("serviceType", {
            type: "10",
            url: item.url,
            title: item.name,
          });
        } else {
          window.open(item.url);
        }
    },
    onLoad() {
      this.loading = true;
      getAdList({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: 1,
      }).then((res) => {
        if (res.code === 2000) {
          this.productList = [...this.productList, ...res.data.recordList];
          this.pageNumber++;
          this.finished = this.productList.length >= res.data.total;
          this.loading = false;
          if (this.productList.length == 0) this.isNoData = true;
        }
      });
    },
    handleClickNotify() {
      this.$router.push({ name: "notify" });
    },
    handleClickCustomerService() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = localStorage.getItem("phone")? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
    initHeaderOverlapObserver() {
      const sentinelEl = this.$refs.contentSentinel;
      if (!sentinelEl || typeof IntersectionObserver === "undefined") return;

      const rootEl = this.$el;
      const headerHeight = 50;
      this._contentObserver?.disconnect();
      this._contentObserver = new IntersectionObserver(
        ([entry]) => {
          this.isHeaderOverlapped = entry ? !entry.isIntersecting : false;
        },
        {
          root: rootEl,
          threshold: 0,
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
        },
      );
      this._contentObserver.observe(sentinelEl);
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: linear-gradient(
    180deg,
    #0d63ef 10%,
    #1d70f7 28.56%,
    rgba(211, 227, 253, 0.2) 67.17%,
    rgba(255, 255, 255, 0) 100%
  );
}
.home {
  ::v-deep(.van-nav-bar) {
    background: #0d63ef !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
  ::v-deep(.van-nav-bar__content) {
    height: 70px;
  }
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.home-overlapped {
  background: #f5f6f7;
}
.left-content {
  display: flex;
  font-size: 18px;
  font-family: "Regular";
  color: #fff;
  align-items: center;
  .guide-logo-icon {
    height: 32px;
  }
  .text {
    padding-left: 3px;
    display: flex;
    flex-direction: column;
  }
  span {
    text-align: left;
  }
  .tip {
    font-size: 11px;
    margin-top: -5px;
  }
}
.content {
  padding: 0px 16px 16px 16px;
}
.content-sentinel {
  height: 1px;
  width: 100%;
}
.block {
  height: 60px;
  background: transparent;
  width: 100%;
}
.notifyIcon {
  width: 24px;
  height: 24px;
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 24px;
}
.title-overlapped {
  position: sticky;
  top: calc(70px + constant(safe-area-inset-top, 0px));
  top: calc(70px + env(safe-area-inset-top, 0px));
  left: 0;
  background: #fff;
  z-index: 9999;
  padding: 10px 0px;
  border-radius: 16px;
}
.product-recommend-card {
  padding: 10px 0px;
  background: #fff;
  border-radius: 16px;
  margin: 0px 16px;
  .title {
    font-weight: 500;
    font-size: 17px;
    color: #373737;
    padding: 10px 16px;
    font-family: "Regular";
    .tip {
      font-size: 11px;
      color: rgba(51, 51, 51, 0.4);
    }
  }
  .product-list {
    margin-top: 13px;
    padding: 0px 16px;
    .product-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f2f7ff;
      padding: 10px 12px;
      border-radius: 8px;
      margin-bottom: 13px;
      .left {
        display: flex;
        align-items: center;
        width: 100%;
        img {
          width: 38px;
          height: 38px;
          margin-right: 8px;
        }
        .product-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 75%;
          .tip {
            font-size: 14px;
            color: #999999;
          }
        }
      }
      .right {
        padding: 6px 11px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #1d70f7;
        border: #1d70f7 solid 1px;
      }
    }
  }
}
.content-sentinel-overlapped {
  position: sticky;
  top: var(--sticky-top); // 吸顶56px
  left: 0;
  background: #f5f6f7;
  z-index: 999;
  padding: 10px 0px;
  height: 11px;
  width: 100%;
}
.up-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px;
  font-size: 12px;
  color: #1d70f7;
  position: fixed;
  right: 15px;
  bottom: 70px;
  .icon {
    width: 28px;
    height: 28px;
    background: #1d70f7;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 17px;
      height: 17px;
    }
  }
}
.warrantyStatement {
  padding: 0px 16px;
}
</style>
